import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;
Container.displayName = 'Container';
export const ContainerSidebar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  height: 42px;
  width: 42px;
  background-color: transparent;
`;
ContainerSidebar.displayName = 'ContainerSidebar';
export const Block = styled.div`
  border-radius: 8px;
  position: absolute;
  top: 0px;
  right: 0;
  z-index: 10;
  cursor: auto;
  max-height: 80vh;
  --max-height: 80vh;
  border-radius: 8px;
  box-shadow: 0px 12px 28px rgba(33, 39, 73, 0.2);
  background-color: #fff;
  overflow: hidden;
`;
Block.displayName = 'Block';
export const CircleDiv = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  color: ${beam.color.pureWhite};
  background: ${beam.color.primaryBlue};

  border-radius: 50%;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  font-size: 10px;
  font-weight: 700;
  right: -5px;
  bottom: -5px;
  width: 14px;
  height: 14px;
`;
